import script from "./Searchbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Searchbox.vue?vue&type=script&setup=true&lang=ts"

import "./Searchbox.vue?vue&type=style&index=0&id=140a74dc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140a74dc"]])

export default __exports__